import { Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { portInOrderList } from '../../../actions/Inteliquent';
import { toast } from 'react-toastify';
import React, { useMemo, useState, useEffect } from 'react';
import Table from '../../../components/Table';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { orderStatusOptions } from './constant';
import utils from '../../../lib/utils';
import { Api } from '../../../lib/api/api';
import SetLimitEntries, { defaultSelectOptions } from '../../../components/SetLimitEntries';
import { ENG_LOCALE } from '../../../lib/constants';
import Pagination from 'rc-pagination';

const defaultPaginationSettings = {
  pageSize: defaultSelectOptions[0],
  page: 1,
};

export default function Home() {
  const token = localStorage.getItem('jwtToken') || null;
  const api = new Api(token);
  const apiVersion = 'v2';
  const dispatch = useDispatch();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pagination, setPagination] = useState({
    page: defaultPaginationSettings.page,
    pageSize: defaultPaginationSettings?.pageSize,
  });

  const {
    register,
    handleSubmit,
    getValues,
    reset,
    formState: { errors, submitCount, isSubmitted, isValid },
  } = useForm({});

  useEffect(() => {
    if (isSubmitted && !isValid) {
      toast.error('Please fix error and submit again');
      console.log(errors, getValues());
    }
  }, [submitCount]);

  const column = useMemo(
    () => [
      {
        dataIndex: 'orderNumber',
        label: 'Order Number',
        sort: ({ orderNumber: a }, { orderNumber: b }) => b - a,
      },
      {
        dataIndex: 'pon',
        label: 'PON',
        sort: ({ pon: a }, { pon: b }) => a.localeCompare(b),
      },
      {
        dataIndex: 'submitted',
        label: (
          <>
            Submitted <small className="font-weight-bolder">MM/DD/YY</small>
          </>
        ),
        render: value => utils.getDateFormate(value),
        sort: ({ submitted: a }, { submitted: b }) => a.localeCompare(b),
      },
      {
        dataIndex: 'status',
        label: 'Status',
        sort: ({ status: a }, { status: b }) => a.localeCompare(b),
      },
      {
        dataIndex: 'totalQuantity',
        label: 'Total Quantity',
        sort: ({ totalQuantity: a }, { totalQuantity: b }) => b - a,
      },
      {
        dataIndex: 'foced',
        label: 'FOCED',
        sort: ({ foced: a }, { foced: b }) => b - a,
      },
      {
        dataIndex: 'rejected',
        label: 'Rejected',
        sort: ({ rejected: a }, { rejected: b }) => b - a,
      },
      {
        dataIndex: 'activated',
        label: 'Activated',
        sort: ({ activated: a }, { activated: b }) => b - a,
      },
      // {
      //   dataIndex: 'focDates',
      //   label: (
      //     <>
      //       FOC Dates
      //        <small className="font-weight-bolder">MM/DD/YY</small>
      //     </>
      //   ),
      //   render: value => value.map((date, index) => <div key={index}>{date}</div>),
      // },
      {
        dataIndex: 'CreatedBy',
        label: 'Created By',
        sort: ({ submitted: a }, { submitted: b }) => a.localeCompare(b),
      },
      {
        label: 'Action',
        render: (_, datum) => (
          <div>
            <Button
              className="mx-1"
              color="primary"
              onClick={() => history.push('/provisioning/porting/order/' + datum.orderNumber)}
            >
              Details
            </Button>
          </div>
        ),
      },
    ],
    [data],
  );

  useEffect(() => {
    onSearch(getValues());
  }, [pagination]);

  async function getResult(values) {
    return await dispatch(
      portInOrderList(token, values, { page: pagination.page, limit: pagination.pageSize })
    );
  }

  function onSearch(values) {
    const loading = toast.info('Loading Data', { toastId: 'loading', autoClose: false });
    getResult(values)
    .then(orderData => {
      if (!orderData.orderList.length) toast.warn('No Data Found');
      setData(orderData.orderList);
      setTotalRecords(orderData.totalItems);
      })
      .catch(console.error)
      .finally(() => toast.dismiss(loading));
  }

  const exportPostOrders = async () => {
    const downloadInfo = toast.info('Your file will download in a moment', { toastId: 'download-info', autoClose: false });
    await api.reports.generatePortOrderReport().catch(err=>{
      console.error(err);
      toast.error("Unable to download. Please try again")
    });
    toast.dismiss(downloadInfo);
  };

  return (
    <div className="text-center">
      <div>
        <div className="mb-3">
          <Button
            className="mx-1"
            onClick={() => history.push('/provisioning/porting/check-service-availability')}
            color="primary"
          >
            Check Service Availability
          </Button>
        </div>
        <div>
          <form className="shadow-none" onSubmit={handleSubmit(onSearch)}>
            <label className="p-3">
              <span className="font-weight-bolder text-left d-block mb-2">Order Number</span>
              <input className="form-control" {...register('orderId')} type="number" />
              {errors?.orderId && (
                <div className="text-danger font-weight-bold">{errors.orderId.message}</div>
              )}
            </label>

            <label className="p-3">
              <span className="font-weight-bolder text-left d-block mb-2">PON</span>
              <input className="form-control" {...register('customerOrderReference')} type="text" />
              {errors?.customerOrderReference && (
                <div className="text-danger font-weight-bold">
                  {errors.customerOrderReference.message}
                </div>
              )}
            </label>

            <label className="p-3">
              <span className="font-weight-bolder text-left d-block mb-2">Submit Date Begin</span>
              <input className="form-control" {...register('createdDateStartRange')} type="date" />
              {errors?.createdDateStartRange && (
                <div className="text-danger font-weight-bold">
                  {errors.createdDateStartRange.message}
                </div>
              )}
            </label>

            <label className="p-3">
              <span className="font-weight-bolder text-left d-block mb-2">Submit Date End</span>
              <input className="form-control" {...register('createdDateEndRange')} type="date" />
              {errors?.createdDateEndRange && (
                <div className="text-danger font-weight-bold">
                  {errors.createdDateEndRange.message}
                </div>
              )}
            </label>

            <label className="p-3">
              <span className="font-weight-bolder text-left d-block mb-2">Order Status</span>
              <select className="form-control" {...register('orderStatus')}>
                <option value="">All</option>
                {orderStatusOptions.map(({ value, text, disabled }) => (
                  <option disabled={disabled} key={value} value={value}>
                    {text}
                  </option>
                ))}
              </select>
              {errors?.orderStatus && (
                <div className="text-danger font-weight-bold">{errors.orderStatus.message}</div>
              )}
            </label>

            <label className="p-3">
              <span className="font-weight-bolder text-left d-block mb-2">Telephone Number</span>
              <input
                className="form-control"
                {...register('tn', {
                  minLength: 10,
                  maxLength: 10,
                })}
                type="text"
              />
              {errors?.tn?.message ? (
                <div className="text-danger font-weight-bold">{errors?.tn?.message}</div>
              ) : (
                (errors?.tn?.type === 'maxLength' || errors?.tn?.type === 'minLength') && (
                  <div className="text-danger font-weight-bold">BTN/ATN Should be of 10 length</div>
                )
              )}
            </label>

            <div class="d-flex">
              <div className="mr-auto p-2">
                <Button
                  onClick={exportPostOrders}
                  className="btn btn-primary"
                  color="primary">
                  Export Port Orders
                </Button>
              </div>

              <div className="p-2">
                <Button
                  type="button"
                  onClick={() => {
                    setData([]);
                    reset();
                    onSearch(getValues());
                  }}
                  className="mr-2"
                >
                  Reset
                </Button>
                <Button color="primary">Search</Button>
              </div>
            </div>
          </form>

          {!!data?.length && (
            <div className="mt-3">
              <Table data={data} column={column} showPagination={true} />
              <div className="row justify-content-center">
                <div className="col-auto">
                  <Pagination
                    locale={ENG_LOCALE}
                    onChange={e => setPagination({ page: e, pageSize: pagination?.pageSize })}
                    current={pagination?.page}
                    total={totalRecords}
                    pageSize={pagination?.pageSize}
                    showLessItems
                    showTitle={false}
                  />
                  <SetLimitEntries
                    onChange={val => setPagination({ page: 1, pageSize: parseInt(val) })}
                    value={pagination?.pageSize}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
